import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 38px;
  height: 22px;
`;

const StyledInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  &:checked + span {
    background-color: ${props =>
      props.theme.background[props.backgroundColor] ||
      props.backgroundColor ||
      props.theme.primary.normal};
  }
  &:checked + span:before {
    left: 18px;
  }
`;

const StyledSpan = styled.span`
  height: 22px;
  width: 38px;
  padding: 0 1px;

  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 22px;
  background-color: #dcdcdc;
  transition: 0.4s;
  &:before {
    width: 18px;
    height: 18px;
    top: 2px;
    border: none;
    background-color: white;
    left: 2px;
    position: absolute;
    content: '';
    border-radius: 50%;
    transition: 0.4s;
  }
`;

const Switch = forwardRef((props, ref) => (
  <StyledLabel>
    <StyledInput type="checkbox" ref={ref} {...props} />
    <StyledSpan />
  </StyledLabel>
));

Switch.propTypes = {
  backgroundColor: PropTypes.string,
};

Switch.defaultProps = {
  backgroundColor: null,
};

export default Switch;
